import { ActionContext } from "vuex";
import { State } from "../state";
import { AssetState } from "./state";
import { commitSetAssets } from "./mutations";
import { getStoreAccessors } from "typesafe-vuex";
import { commitAddNotification } from "@/store/main/mutations";
import { eventMonitor } from "@/api/eventMonitor";

// Pass in the state management context
type MainContext = ActionContext<AssetState, State>;

export const actions = {
  async actionGetAssets(context: MainContext): Promise<void> {
    try {
      const response = await eventMonitor.getAssets(
        context.rootState.main.token
      );
      if (response) {
        commitSetAssets(context, response.data);
      }
    } catch (error) {
      console.log(error);
      commitAddNotification(context, {
        content: "Error getting assets",
        color: "error",
      });
    }
  },
};

const { dispatch } = getStoreAccessors<AssetState, State>("");

export const dispatchActionGetAssets = dispatch(actions.actionGetAssets);
